<template>
    <div id="app">
        <a id="goToTop"></a>
        <router-view v-if="isRouterAlive"/>
    </div>
</template>
<script>
export default {
    name:'app',
    provide(){
        return {
            reload:this.reload
        }
    },
    data(){
        return {
            isRouterAlive:true
        }
    },
    methods:{
        reload(){
            this.isRouterAlive=false
            this.$nextTick(function(){
                this.isRouterAlive=true
            })
        }
    },
    watch:{
      "$route.path": function(newVal, oldVal) {
        document.querySelector("#goToTop").scrollIntoView(true);
    },
  },
}
</script>
<style lang="scss" scoped>
    #app {
        height: 100%;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    @media screen and (min-height: 500px) {
        html {
            font-size: 12px;
        }
    }

    @media screen and (min-height: 800px) {
        html {
            font-size: 14px;
        }
    }
</style>
